import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { getDeviceSubtype } from '../selectors/config'
import DeviceSubtypes from '../utils/deviceSubtypes'
import ConnectingIndicator from '../components/ConnectingIndicator'

const DeviceSubtypeRouter = ({ deviceSubtype, hasActiveSession, hasActiveCurrentMenu, history }) => {

  const deviceSubtypeRootPath = () => {
    const accessToken = localStorage.getItem('accessToken')
    if (DeviceSubtypes.isConcessions(deviceSubtype)) {
      return '/concession-order'
    } else if (DeviceSubtypes.isKiosk(deviceSubtype)) {
      return '/kiosk/attract_loop'
    } else if (DeviceSubtypes.isSuites(deviceSubtype)) {
      return hasActiveSession ? '/tabs' : '/user-login'
    } else if (DeviceSubtypes.isTabs(deviceSubtype)) {
      return '/tabs'
    } else if (!!accessToken) {
      return '/revenue-center-setup'
    } else {
      return '/device-login'
    }
  }

  useEffect(() => {
    history.push(deviceSubtypeRootPath())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceSubtype])

  return <ConnectingIndicator />

}

const mapStateToProps = (state) => {
  const deviceSubtype = getDeviceSubtype(state)
  const hasActiveSession = Boolean(state?.salesEvent?.activeEventId && state?.attendant?.activeAttendantId)

  return {
    deviceSubtype,
    hasActiveSession,
  }
}

export default withRouter(connect(mapStateToProps, undefined)(DeviceSubtypeRouter))
